import axiosapi from "../api/axiosapi";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import useAuth from "../hooks/useAuth";

const ExerciseCalculationList = () => {
    const [exerciseCalculationList, setExerciseCalculationList] = useState([]);
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);
    const [openSection, setOpenSection] = useState(null);
    
    const toggle = (id) => {
        setOpenSection(openSection === id ? null : id);
    };

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchexerciseCalculationList = async () => {
            try {
                const response = await axiosapi.get('/exercise/subjectncategory/list/')
                response.data && setExerciseCalculationList(response.data);
            } catch(err) {
                console.log(err)
            }
        }

        fetchexerciseCalculationList();
    },[])

    return(
        <div className="vertical-flex-container-1">
            <div className="content-box-1">
                {exerciseCalculationList && exerciseCalculationList.map(grade => {
                    return(
                        <div key={grade.subjectCode} className="section">
                            <div
                                className={`section-bar ${openSection === grade.subjectTitle ? "active" : ""}`}
                                onClick={() => toggle(`${grade.subjectTitle}`)}
                            >
                                <span>{grade.subjectTitle}</span>
                                <span className="arrow">▼</span>
                            </div>

                            <div className={`card-container ${openSection === grade.subjectTitle ? "open" : ""}`}>
                                {grade.categories && grade.categories.map( cate => {
                                    return(
                                        <div key={cate.categoryCode} className="card">
                                            <h5>{cate.categoryTitle}</h5>
                                            <p>{cate.categoryDescription}</p>
                                            <Link 
                                                to={`/calculationexercise/` }
                                                state={{
                                                    "categoryCode": cate.categoryCode,
                                                    "problemCode": cate.firstProblemCode,
                                                    "categoryTitle": cate.categoryTitle
                                                }}
                                            >
                                                바로가기
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>
            <div style={{width: "100%"}}>
                <Footer/>
            </div>
        </div>
    )
}

export default ExerciseCalculationList;
